import { render, staticRenderFns } from "./ResourceOption.vue?vue&type=template&id=03bcf7c8&scoped=true&v-if=imageOption%20%7C%7C%20videoOption"
import script from "./ResourceOption.vue?vue&type=script&lang=js"
export * from "./ResourceOption.vue?vue&type=script&lang=js"
import style0 from "./ResourceOption.vue?vue&type=style&index=0&id=03bcf7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bcf7c8",
  null
  
)

export default component.exports